import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/images/ImageButtonList.js";
import React, { Component } from 'react';
import { Grid, Button, Typography, TextField, List, ListItem, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Dialog, Pagination, SimpleSnackbar } from '../common';
import Util from "../../util/Util";
import { BASE_URIS, ID_SPACE, IMAGE_BUTTON_LIST_QUALIFIERS, Q_STRING, SORT_FIELD, TPIS_PARAMS, IMAGE_DISPLAY_MODE } from "../domain/constants";
import queryString from "query-string";
import { changeSearchValue, setUpPageInfoFromQueryString, determinePageSize } from "../../util/QueryStringUtil";
const styles = theme => ({
  img: {
    display: 'block',
    maxWidth: '30vh',
    maxHeight: '30vh',
    width: 'auto',
    height: 'auto'
  },
  positive: {
    color: '#49dd40',
    margin: theme.spacing(2)
  },
  neutral: {
    color: '#ffeb3b',
    margin: theme.spacing(2)
  },
  negative: {
    color: 'red',
    margin: theme.spacing(2)
  },
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  }
});
class ImageButtonList extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "addAuditNotes", itemId => event => {
      const auditNotes = this.state.auditNotes;
      auditNotes[itemId] = event.target.value;
      this.forceUpdate();
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const pageSize = determinePageSize(querystringValues, props);
    this.state = {
      qualifier: props.qualifier,
      baseUri: props.baseUri,
      images: [],
      // never set this to null
      auditNotes: {},
      // never set this to null
      loaded: true,
      page: 0,
      pageSize: pageSize,
      morePages: true,
      totalPages: 0,
      totalElements: 0,
      sortField: SORT_FIELD.title,
      sortDescending: false,
      mode: IMAGE_DISPLAY_MODE.BY_ASSOCIATION
    };
    this.loadContent();
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
    this.snackbarRef = null;
    this.setSnackbarRef = element => {
      this.snackbarRef = element;
    };
  }
  reset() {
    this.state.images = []; // never set this to null
    this.state.page = 0;
    this.state.morePages = true;
    this.loadContent();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    setUpPageInfoFromQueryString(this);
  }
  loadContent() {
    this.state.loaded = false;
    this.state.images = [];
    this.state.auditNotes = {};
    this.state.morePages = true;
    this.forceUpdate();
    const uri = this.makeUri();
    Util.fetchWithRedirect(uri, 'GET', this.props).then(result => {
      const newContent = result.content;

      // just in case
      if (this.state.qualifier === IMAGE_BUTTON_LIST_QUALIFIERS.quickAudit) {
        if (this.state.mode === IMAGE_DISPLAY_MODE.BY_IMAGE) {
          this.addToImagesFromImagesCall(newContent);
        } else if (this.state.mode === IMAGE_DISPLAY_MODE.BY_ASSOCIATION) {
          this.addToImagesFromAssociationsCall(newContent);
        }
      }
      this.setState({
        loaded: true,
        morePages: !result.last,
        totalPages: result.totalPages,
        totalElements: result.totalElements
      });
    }).catch(e => {
      Util.log('ImageButtonList.loadContent', true, e, false);
      this.setState({
        loaded: true,
        e
      });
    });
  }
  addToImagesFromImagesCall(newContent) {
    const auditNotes = this.state.auditNotes;
    newContent.forEach(image => {
      let associations = image.associations;
      let entityIds = [];
      if (associations !== undefined && associations !== null) {
        associations.map(assoc => {
          if (assoc.entityProvider === ID_SPACE.ADI) {
            entityIds.push(assoc.entityId);
          }
        });
      }
      let imageButtonListObject = {
        entityIds: entityIds,
        id: image.id,
        url: image.url
      };
      if (image.auditDescription != null && image.auditDescription !== '') {
        auditNotes[image.id] = image.auditDescription;
      }
      this.state.images.push(imageButtonListObject);
    });
  }
  addToImagesFromAssociationsCall(newContent) {
    const auditNotes = this.state.auditNotes;
    newContent.forEach(association => {
      let image = association.image;
      let entityProvider = association.entityProvider;
      let entityId = association.entityId;
      let imageButtonListObject = {
        id: image.id,
        url: image.url,
        entityId,
        entityProvider
      };
      if (image.auditDescription != null && image.auditDescription !== '') {
        auditNotes[image.id] = image.auditDescription;
      }
      this.state.images.push(imageButtonListObject);
    });
  }
  makeUri() {
    let uri = BASE_URIS.prefix + this.state.baseUri + "?".concat(TPIS_PARAMS.PAGE, "=").concat(this.state.page) + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=").concat(this.state.pageSize) + "&".concat(TPIS_PARAMS.SORT_FIELD, "=").concat(this.state.sortField) + "&".concat(TPIS_PARAMS.SORT_DESC, "=").concat(this.state.sortDescending);
    if (this.state.qualifier === IMAGE_BUTTON_LIST_QUALIFIERS.quickAudit) {
      uri += TPIS_PARAMS.AUDIT_PENDING;
    }
    if (this.state.baseUri === BASE_URIS.listImages) {
      uri += TPIS_PARAMS.INCLUDE_ASSOCIATIONS;
    } else if (this.state.baseUri === BASE_URIS.listAssociations) {
      uri += TPIS_PARAMS.INCLUDE_IMAGE;
    }
    return uri;
  }
  audit(item, action) {
    let uri = BASE_URIS.prefix + "".concat(BASE_URIS.audit, "?").concat(TPIS_PARAMS.IMAGE_ID, "=").concat(item.id) + "&".concat(TPIS_PARAMS.ACTION, "=").concat(action);
    if (item.entityId != null && item.entityProvider != null) {
      uri += "&".concat(TPIS_PARAMS.PROVIDER, "=").concat(item.entityProvider, "&").concat(TPIS_PARAMS.ENTITY_ID, "=").concat(item.entityId);
    }
    let auditNotes = this.state.auditNotes[item.id];
    if (auditNotes != null && auditNotes !== '') {
      uri += "&".concat(TPIS_PARAMS.DESCRIPTION, "=").concat(auditNotes);
    }
    Util.fetchWithRedirect(uri, 'POST', this.props).then(resp => {
      const images = resp.images;
      if (images == null || images.length === 0) {
        Util.log('ImageButtonList.audit', true, "There were no images returned in the audit call: ".concat(uri, "\n Displaying image status according to action: ").concat(action), false);
      }
      Util.openSnackbar('Audit Successful', this.snackbarRef);
      if (this.state.images.length === 1) {
        // there are no more images on the current page, since we just audited the last one
        if (this.state.page > 0) {
          this.state.page = this.state.page - 1;
          changeSearchValue(Q_STRING.PAGE, this.state.page + 1, this.props);
        }
        this.loadContent();
      } else {
        this.loadContent();
      }
    }).catch(e => {
      Util.createDialog('', 'Audit was not successful', this.dialogRef);
      Util.log('ImageButtonList.audit', true, e, true);
    });
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      images = _this$state.images,
      qualifier = _this$state.qualifier;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'space-between',
      alignItems: 'space-between',
      direction: 'column',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 244,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 21
      }
    })), Pagination(this.state, this, classes, true), images.length !== 0 && images.map(item => /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'center',
      alignItems: 'center',
      direction: 'row',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 251,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'flex-start',
      alignItems: 'center',
      direction: 'row',
      wrap: 'nowrap',
      spacing: 1,
      md: 8,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: item.url,
      target: "_blank",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 255,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url,
      alt: item.url,
      className: classes.img,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 256,
        columnNumber: 37
      }
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'center',
      alignItems: 'center',
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 25
      }
    }, item.entityIds != null && item.entityIds.length !== 0 || item.entityId != null && item.entityProvider != null ? this.displayIds(item) : /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 265,
        columnNumber: 33
      }
    }, "Entity ID Not Available")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'center',
      alignItems: 'center',
      direction: 'row',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 268,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "outlined-multiline-static",
      label: "Audit Notes",
      multiline: true,
      rows: "4",
      value: this.state.auditNotes[item.id],
      placeholder: "Any notes to accompany audit decision (optional)",
      className: classes.textField,
      margin: "normal",
      variant: "outlined",
      onChange: this.addAuditNotes(item.id),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 269,
        columnNumber: 29
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: 'center',
      justify: 'flex-end',
      alignItems: 'center',
      direction: 'row',
      wrap: 'nowrap',
      spacing: 1,
      md: 4,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 25
      }
    }, qualifier === IMAGE_BUTTON_LIST_QUALIFIERS.quickAudit && [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'contained',
      color: 'primary',
      onClick: () => this.audit(item, 'ACCEPT'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279,
        columnNumber: 44
      }
    }, "Accept")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 280,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'contained',
      color: 'secondary',
      onClick: () => this.audit(item, 'REJECT'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 280,
        columnNumber: 44
      }
    }, "Reject"))], qualifier === 'quick-publish' && [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 284,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'contained',
      color: 'primary',
      onClick: () => this.publish(item, 'PUBLISH'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 284,
        columnNumber: 44
      }
    }, "Publish")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 285,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'contained',
      color: 'secondary',
      onClick: () => this.publish(item, 'UNPUBLISH'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 285,
        columnNumber: 44
      }
    }, "Unpublish"))]))), (images === null || images.length === 0) && /*#__PURE__*/React.createElement(Typography, {
      align: 'center',
      component: "div",
      style: {
        padding: 8 * 3
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 291,
        columnNumber: 17
      }
    }, "There is no content in this queue"), Pagination(this.state, this, classes, false));
  }
  displayIds(item) {
    const entityIds = item.entityIds,
      entityId = item.entityId,
      entityProvider = item.entityProvider;
    if (this.state.mode === IMAGE_DISPLAY_MODE.BY_IMAGE) {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 302,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 303,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 304,
          columnNumber: 25
        }
      }, "Entity IDs:"), /*#__PURE__*/React.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 307,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(List, {
        dense: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 308,
          columnNumber: 29
        }
      }, entityIds.map(entityId => /*#__PURE__*/React.createElement(ListItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 310,
          columnNumber: 37
        }
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: entityId,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 311,
          columnNumber: 41
        }
      })))))));
    } else if (this.state.mode === IMAGE_DISPLAY_MODE.BY_ASSOCIATION) {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        direction: 'column',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 323,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        md: 6,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 324,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 325,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement("strong", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 325,
          columnNumber: 59
        }
      }, "Provider:"), " ", entityProvider)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        md: 6,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 327,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 328,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement("strong", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 328,
          columnNumber: 59
        }
      }, "EntityId:"), " ", entityId)));
    }
  }
}
export default withStyles(styles)(withRouter(ImageButtonList));